module.exports = __webpack_public_path__ + "static/assets/d5f5febae78306a2394c6ba6768440de.png";